import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"
import {
 selectOrdersData, resendAsync, 
} from './ordersSlice';
import styled from 'styled-components'
import { useTable, useRowSelect , usePagination} from 'react-table'
import Modal from 'react-modal';
import styles from './orders.module.css';


const Styled = styled.div`
  padding: 1rem;

  table {
    border-spacing: 0;
    border: 1px solid black;
    color : white;
    color: b7d9ee;
    background-color: black;
  

    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }

    th,
    td {
      margin: 0;
      padding: 0.5rem;
      border-bottom: 1px solid black;
      border-right: 1px solid black;

      :last-child {
        border-right: 0;
      }
    }
  }
`


function Table({ columns, data }) {
  const dispatch = useDispatch();
 

  const [showID, setShowID] = useState('');
  const [ResendButton,setResendButton] = useState('');
  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    //rows,
    page,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    setPageSize,
    pageOptions,
    prepareRow,
    state: { pageIndex, pageSize },// , selectedRowIds },
  } = useTable(
    {
      columns,
      data,
    },
    usePagination,
    useRowSelect,
    hooks => {
      hooks.visibleColumns.push(columns => [
        // Let's make a column for selection
        {
          id: 'selection',
          // The header can use the table's getToggleAllRowsSelectedProps method
          // to render a checkbox
          Header: ({ getToggleAllPageRowsSelectedProps }) => (
            <div key={'displayViewNoBtn'}>
              View
            </div>
          ),
          // The cell can use the individual row's getToggleRowSelectedProps method
          // to the render a checkbox
          Cell: ({ row }) => (

                <button key = {`btn{row}`} className="{styles.button}"
                        value={row} onClick={()=>
                        { setShowIDWithData(row.id,row.original.id)
                          console.log('clicked on row.id ' + row.original.id) 
                        console.log('clicked')
                        }
                      }>
                      View
                    </button>

          ),
        },

        ...columns,
      ])
    }
  )


  const setShowIDWithData = (id,actualId) => {
    let orm ='';
    let j = '';
    let oru = '';
    let ormData = '';
    //let msh = '';
    let display = '';
    let messageType = '';
    if (data[id].hasOwnProperty('type')) {
      if (data[id].type =='ph_orm'){
        //messageType = 'ph_order';
        orm = data[id].FullMessage.replaceAll("\",","\",\r\n");
        display = orm;
        setResendButton(true)
      }
      else if (data[id].type =='ph_prefetch'){
        messageType = 'ph_prefetch';
        orm = data[id].message.replaceAll("\",","\",\r\n");
        ormData = JSON.parse(data[id].message); //.message.Studies
        console.log(ormData);
        console.log('typeof is next')
        console.log(ormData)
        console.log(typeof ormData)
        var count = ormData.Studies.length;//Object.keys(ormData.Studies - 1);
        var countTrue = 0;
        
        var output='';
        for (let [k, v] of Object.entries(ormData.Studies)) {
          if (k > 0) output = output + "\r\n";
          output = output + `${v.Selected} - ${v.AccessionNumber} - ${v.Description} - ${v.DateTime}`;
          console.log(output);
          if (v.Selected == true) {countTrue++;};
        }

        orm = `Count of Priors Pulled : ${countTrue} / ${count}`;
        orm = `${orm}\r\n\r\n${output}\r\n\r\n`;
        //orm = orm + ormData.replaceAll("\",","\",\r\n");
        
        display = orm;
      }
    }

    else if (data[id].hasOwnProperty('orm')) {
      messageType = 'order';
      orm = data[id].orm.replaceAll("\",","\",\r\n");
      j = JSON.parse(data[id].orm)['ORMMessage'];
      //msh = ((j !== undefined) && (j.length > 0)) ? j.replaceAll("|","|\r\n") : 'Missing MSH';
      let mshStart = data[id].orm.indexOf('MSH');
      let mshData = data[id].orm.slice(mshStart).replaceAll("\\r","\r\n");
      let mshEnd = mshData.indexOf('",');
      let ormEnd = mshData.slice(mshEnd+2).replaceAll("\",","\",\r\n");
      mshData = mshData.slice(0,mshEnd);
      orm = data[id].orm.replaceAll("\",","\",\r\n").slice(1,mshStart-2);
      display = orm + "\r\n\r\n" + mshData + "\r\n\r\n" + ormEnd;
      setResendButton(true);
    }

    else if (data[id].hasOwnProperty('oru')) {
      messageType = 'result';
      let ackStart = data[id].oru.indexOf('"Ack":');
      let ackData = data[id].oru.slice(ackStart) 
      let mshStart = data[id].oru.indexOf('MSH');
      let mshData = data[id].oru.slice(mshStart,ackStart-2).replaceAll("\\r","\r\n");
      oru = data[id].oru.replaceAll("\",","\",\r\n").slice(1,mshStart-2);
      console.log(data[id]);
      //j = JSON.parse(data[id].oru)['ORMMessage'];
      setResendButton(true)
      display = oru + "\r\n\r\n" + ackData + "\r\n\r\n" + mshData + "\r\n\r\n";
    }
    else if (data[id].hasOwnProperty('PriorORU')){
      messageType = 'priorORU';
      orm = data[id].PriorORU.replaceAll("\",","\",\r\n");
      display = orm;
      setResendButton(true)
    }
  
    
    //console.log(`calling setShowID with ${messageType}`)
    setShowID({id,display,actualId,messageType});
  } 

  // Render the UI for your table
  return (
    <React.Fragment>


<div className="pagination">
        <button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
          {'<<'}
        </button>{' '}
        <button onClick={() => previousPage()} disabled={!canPreviousPage}>
          {'<'}
        </button>{' '}
        <button onClick={() => nextPage()} disabled={!canNextPage}>
          {'>'}
        </button>{' '}
        <button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
          {'>>'}
        </button>{' '}
        <span>
          Page{' '}
          <strong>
            {pageIndex + 1} of {pageOptions.length}
          </strong>{' '}
        </span>
        <span>
          | Go to page:{' '}
          <input
            type="number"
            defaultValue={pageIndex + 1}
            onChange={e => {
              const page = e.target.value ? Number(e.target.value) - 1 : 0
              gotoPage(page)
            }}
            style={{ width: '100px' }}
          />
        </span>{' '}
        <select
          value={pageSize}
          onChange={e => {
            setPageSize(Number(e.target.value))
          }}
        >
          {[10, 20, 30, 40, 50].map(pageSize => (
            <option key={pageSize} value={pageSize}>
              Show {pageSize}
            </option>
          ))}
        </select>
      </div>
  

      <table {...getTableProps()}>
        <thead>
          {headerGroups.map(headerGroup => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => (
                <th {...column.getHeaderProps()}>{column.render('Header')}</th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row, i) => {
            prepareRow(row)
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map(cell => (
                    <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                ))}
              </tr>
            )
          })}
        </tbody>
      </table>

      <div className="pagination">
        <button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
          {'<<'}
        </button>{' '}
        <button onClick={() => previousPage()} disabled={!canPreviousPage}>
          {'<'}
        </button>{' '}
        <button onClick={() => nextPage()} disabled={!canNextPage}>
          {'>'}
        </button>{' '}
        <button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
          {'>>'}
        </button>{' '}
        <span>
          Page{' '}
          <strong>
            {pageIndex + 1} of {pageOptions.length}
          </strong>{' '}
        </span>
        <span>
          | Go to page:{' '}
          <input
            type="number"
            defaultValue={pageIndex + 1}
            onChange={e => {
              const page = e.target.value ? Number(e.target.value) - 1 : 0
              gotoPage(page)
            }}
            style={{ width: '100px' }}
          />
        </span>{' '}
        <select
          value={pageSize}
          onChange={e => {
            setPageSize(Number(e.target.value))
          }}
        >
          {[10, 20, 30, 40, 50].map(pageSize => (
            <option key={pageSize} value={pageSize}>
              Show {pageSize}
            </option>
          ))}
        </select>
 
      </div>



      <Modal 
      className={styles.modal}
      isOpen={(showID) ? true : false} 
      ariaHideApp={false}
      >
      <button 
        key='setShowIDbtn' 
        onClick={()=>setShowID('')
        }
      >
        Close
      </button>


      {
      (ResendButton == true) ?
      <button key='resendBtn' 
        onClick={()=>{
          console.log(`showID.messageTypes is ${showID.messageType}`)
          dispatch(resendAsync(showID.actualId,showID.messageType))
          console.log('resending')} 
        }
      >
        Resend to DocPanel
      </button> : ''
      
      }

                          <div className={styles.dialog}>
                          <pre>
                        {
                        (showID) ?  
                        
                        showID.display
                        
                        
                        : ''
                      }
                        </pre>
                        </div>
                        
                        </Modal>
      
      
    </React.Fragment>
  )
}

function buildDisplay(ordersData){

//set default
  let displayArray = [
    {
      Header: 'Patient',
      accessor:'patientHeaderKey',
      columns: [
        {
          Header: 'MRN',
          accessor: 'PatientMrn',
        },
        {
          Header: 'Image Center',
          accessor: 'ImageCenterName',
        },
        {
          Header: 'AccessionNumber',
          accessor: 'AccessionNumber',
        },
        {
          Header: 'Date Received',
          accessor: 'dateReceived',
        },
      ],
    },
  ];
  

  if (ordersData.length < 1) {
    return  displayArray;
  }
  if (ordersData[0].hasOwnProperty('type')) {
      if (ordersData[0].type =='mach7Search'){
        console.log('this is a mach7 search')
        
        

            displayArray = [
                {
                  Header: 'Patient',
                  accessor:'patientHeaderKey',
                  columns: [
                    {
                      Header: 'MRN',
                      accessor: 'PatientMrn',
                    },
                    {
                      Header: 'Image Center',
                      accessor: 'ImageCenterName',
                    },
                    {
                      Header: 'AccessionNumber',
                      accessor: 'AccessionNumber',
                    },
                    {
                      Header: 'Study Date',
                      accessor: 'StudyDate',
                    },
                    {
                      Header: 'Procedure Description',
                      accessor: 'ProcedureDescription',
                    },
                    {
                      Header: 'KeyImage Found',
                      accessor: 'KeyImage',
                    },
                  ],
                },
              ]
      }
    }

    

    return displayArray;

}

function DisplayTable(data) {



  

  let { ordersData }  = useSelector(selectOrdersData);
  
  console.log(`ordersData in displaytable next`);
  console.log(JSON.stringify(ordersData));
  console.log('data next');
  console.log(JSON.stringify(data));

  let displayArray = buildDisplay(ordersData);

  
  
  const columns = React.useMemo(
    (ordersData) => displayArray,[]
  )
  

//  const data = React.useMemo(() => ordersData, [])

  return (
    <Styled>
      {(ordersData.length < 1) ? <div className={styles.rowWhite}> 
      'No Records Found'</div> : <Table columns={columns} data={ordersData} />}
    </Styled>
  )
}

export default DisplayTable